module.exports = __webpack_public_path__ + "static/media/logo2.d55a59a1.png";